<template>
	<v-popover class="popover" trigger="hover click" placement="top" offset="18">
		<button class="tooltip-icon" />
		<template slot="popover">
			<div class="tooltip">{{ text }}</div>
		</template>
	</v-popover>
</template>

<script>
export default {
	name: 'Tooltip',
	props: {
		text: {
			type: String,
			required: true,
		},
	},
};
</script>
